import FontAwesomeIcon from "./FontAwesomeIcon";

export default function AsteriskIcon({ ...props }) {
  return <FontAwesomeIcon name="asterisk" {...props} />;
}
